module.exports = __webpack_public_path__ + "static/pic7-13cfb27bfec73a992080237582ee3bcb.jpg";